export * from './aside.directive';



// WEBPACK FOOTER //
// ./src/app/directives/aside/index.ts